module.exports = __webpack_public_path__ + "img/AmBank.047bfb14.png";